import React from 'react';

const JoinClassStep = () => {
  return <div>You have joined the class.</div>;
};

export default JoinClassStep;
